import React, { useEffect, useRef, useState } from 'react';
import MediaPlaceholder from './MediaPlaceholder';
import { toEmbedUrl } from '../utils/embedUrl';
import '../App.css';

// A help video that loads nothing from YouTube until the reader presses Play
// (#1077). Until then it is the branded title card, the same card the video itself
// opens on, so pressing Play looks like the video starting rather than a swap. The
// privacy policy promises exactly this, so the iframe must never render before the press.
export interface HelpVideoProps {
  /** The YouTube link pasted in /admin/help. */
  src: string;
  eyebrow?: string;
  title?: string;
  duration?: string;
}

const HelpVideo: React.FC<HelpVideoProps> = ({ src, eyebrow, title, duration }) => {
  const [playing, setPlaying] = useState(false);
  const frame = useRef<HTMLIFrameElement>(null);
  const embedUrl = toEmbedUrl(src, { autoplay: true });

  // The Play button disappears when pressed, so a keyboard reader's focus moves to the
  // player that replaced it rather than falling back to the top of the page.
  useEffect(() => { if (playing) frame.current?.focus(); }, [playing]);

  // A link we can't play reads as a video that isn't ready, as before.
  if (!embedUrl) return <MediaPlaceholder eyebrow={eyebrow} title={title} duration={duration} />;

  if (!playing) {
    return <MediaPlaceholder eyebrow={eyebrow} title={title} duration={duration} onPlay={() => setPlaying(true)} />;
  }
  return (
    <div className="tut-video">
      <iframe ref={frame} src={embedUrl} title={title || 'Help video'}
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowFullScreen />
    </div>
  );
};

export default HelpVideo;
